export default __webpack_public_path__ + "static/media/C.11c6e514.mp3";